import { createFileRoute } from '@tanstack/react-router';

import { ServiceAssociationWizard } from '../../pages/service-association/ServiceAssociationWizard';

export const Route = createFileRoute('/_auth/associated-services/$serviceModelCode')({
  component: ServiceAssociationWizard,
});
